<template>
  <v-dialog v-model="value" persistent max-width="450px">
    <pd-card>
      <v-card-title>{{
        $t("pages.signin_signup.resetPassword.dialogTitle")
      }}</v-card-title>
      <v-card-text>
        {{ $t("pages.signin_signup.resetPassword.dialogText") }}
        <v-form ref="mailForm" v-model="validMail">
          <v-text-field
            v-model="email"
            dense
            outlined
            :label="$t('pages.signin_signup.resetPassword.email')"
            :rules="emailRules"
            style="margin-top: 20px"
            placeholder=" "
            autocomplete="off"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text tile depressed color="red" @click="closeDialog">{{
          $t("pages.signin_signup.resetPassword.dialogAbort")
        }}</v-btn>
        <v-btn
          text
          tile
          depressed
          color="blue"
          :disabled="!validMail"
          :loading="mailSending"
          @click="sendRecoveryAccountMail"
          >{{ $t("pages.signin_signup.resetPassword.dialogSend") }}</v-btn
        >
      </v-card-actions>
    </pd-card>
  </v-dialog>
</template>

<script>
import PdCard from "Components/pd-card";
import * as a from "../store/types/actions.types";
export default {
  data() {
    return {
      email: "",
      validMail: false,
      mailSending: false,
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    emailRules: {
      type: Array,
      default: [],
    },
  },
  methods: {
    sendRecoveryAccountMail() {
      this.mailSending = true;
      this.$store
        .dispatch("ResetPassword/" + a.SEND_RECOVERY_MAIL, {
          email: this.email,
        })
        .then((r) => {
          this.mailSending = false;
          if (r.status == "200") {
            this.$emit("success");
            this.$refs.mailForm.reset();
            this.$emit("close");
          }
        })
        .finally(() => {
          this.mailSending = false;
        });
    },
    closeDialog() {
      this.$refs.mailForm.reset();
      this.$emit("close");
    },
  },
  components: {
    PdCard,
  },
};
</script>

<style></style>
